<script setup lang="ts">
defineProps<{
  text?: string | null;
  enabled: boolean;
  animated: boolean;
  color?: string;
  background?: string;
}>();
</script>

<template>
  <div
      v-if="enabled && text?.trim()"
      class="announcement"
      :style="{
      '--bg': background,
      '--text': color
    }"
  >
    <div class="announcement-content" :class="{ 'announcement-inner': animated }" v-html="text"></div>
  </div>
</template>

<style scoped>
.announcement {
  background: var(--bg);
  color: var(--text);
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  font-weight: var(--fw-bold, 700);
  font-size: var(--fs--1, 13px);
  text-align: center;
  padding: 4px 0;
}

.announcement:hover .announcement-inner,
.announcement:focus-within .announcement-inner {
  animation-play-state: paused;
}

.announcement-content :deep(p) {
  margin: 0;
}

.announcement-content :deep(a) {
  color: inherit;
}

.announcement-inner {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 18s linear infinite;
  color: var(--text);

}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
